<template>
  <div>
    <template slot="footer">
      <van-button v-show="false" @click="cancel">关闭</van-button>
    </template>
    <div style="height: 100vh; width: 100%">
      <baidu-map
        style="height: 100%; width: 100%"
        :center="currentPoint"
        :zoom="zoom"
        :scroll-wheel-zoom="true"
        @ready="initMap"
      >
        <bm-marker
          :position="currentPoint"
          :icon="{
            url: require(`@/assets/car/online.png`),
            size: { width: 36, height: 36 },
          }"
          @click="openInfo"
        ></bm-marker>
        <bm-info-window
          :position="currentPoint"
          :title="`<div style='color:#000000;font-weight:600;font-size:18px;'>设备详情 - ${
            devicedata.carNum || devicedata.carVin || devicedata.sn
          }</div>`"
          :show="shows"
          class="info"
          style="width: 400px; min-height: 350px"
          @close="colseInfo"
        >
          <van-row class="info-window-content">
            <van-col :span="24">
              <span class="title">车辆信息</span>
              <div v-if="devicedata?.brand">
                <span class="fontone">车辆品牌:</span>
                {{ devicedata.brand ? `${devicedata.brand}` : '--' }}
              </div>
              <div>
                <span class="fontone">车架号:</span>
                {{ devicedata.carVin }}
              </div>
              <div>
                <span class="fontone">设备号:</span>
                <span v-if="deviceList?.length === 1">{{ devicedata.sn }}</span>
                <select v-model="deviceId" @change="changeDevice" v-else>
                  <option
                    v-for="item in deviceList"
                    :key="item.value"
                    :value="item.deviceId"
                  >
                    {{ item.sn }} （{{ item.wifi ? '无线' : '有线' }}）
                  </option>
                </select>
              </div>
            </van-col>
          </van-row>
          <van-row class="location-info">
            <van-col
              :span="24"
              v-if="devicedata.reportGps === 1 && devicedata.gpsTime"
            >
              <span class="title">GPS定位</span>
              <div>
                <span class="fontone">最后定位时间:</span>
                {{ devicedata.gpsTime }}
              </div>
              <div>
                <span class="fontone">最后定位位置:</span>
                {{ devicedata.gpsAddress }}
              </div>
              <div class="fontred">注：GPS定位精确度约为10米以内</div>
            </van-col>
            <van-col
              :span="24"
              v-if="devicedata.reportGms === 1 && devicedata.gsmTime"
              class="martin-top-10"
            >
              <span class="title">基站定位</span>
              <div>
                <span class="fontone">最后定位时间:</span>
                {{ devicedata.gsmTime }}
              </div>
              <div>
                <span class="fontone">最后定位位置:</span>
                {{ devicedata.gsmAddress }}
              </div>
              <div class="fontred">注：基站定位精确度约为50-1000米</div>
            </van-col>
            <van-col
              :span="24"
              v-if="devicedata.reportWifi === 1 && devicedata.wifiTime"
              class="martin-top-10"
            >
              <span class="title">WIFI定位</span>
              <div>
                <span class="fontone">最后定位时间:</span>
                {{ devicedata.wifiTime }}
              </div>
              <div>
                <span class="fontone">最后定位位置:</span>
                {{ devicedata.wifiAddress }}
              </div>
              <div class="fontred">注：基站定位精确度约为50-1000米</div>
            </van-col>
            <van-col :span="24" v-if="devicedata.updatetime">
              <span class="title">设备</span>
              <div>
                【{{ devicedata.alias
                }}{{ devicedata.wifi === 1 ? '无线' : '有线' }}】
              </div>
              <div>
                <span class="fontone">设备状态:</span>
                {{ devicedata.statusDevice }}
              </div>
              <div>
                <span class="fontone">最后上传时间:</span>
                {{ devicedata.updatetime }}
              </div>
            </van-col>
            <van-col :span="24"
              ><span @click="viewGrack" class="viewGrack"
                >查看轨迹</span
              ></van-col
            >
          </van-row>
        </bm-info-window>
      </baidu-map>
    </div>
  </div>
</template>
<script>
import { getDeviceInfo } from '@/api/device'
export default {
  props: {},
  data() {
    return {
      zoom: 18,
      visible: false,
      shows: true,
      currentPoint: {
        lng: 120.320032,
        lat: 31.589666,
      },
      devicedata: {
        // carvin: '粤B46500',
        // sn: '123123232',
        // reportGps: 1,
        // gpstime: '2023-02-24 14:35:00',
        // gpsAddress: '深圳市南山区高新园区北科大厦415',
        // updatetime: '2023-02-24 14:35:00',
        // alias: 'JR-02',
        // wifi: 1,
        // statusDevice: '油电通，设备在线',
        // brand: '马萨拉蒂'
      },
      deviceId: 0,
      deviceList: [],
      BMap: null,
      map: null,
      key: '', // 外部参数 登录 Token
      fun: '', // 外部参数 功能
      imei: '', // 外部参数 设备号
      carVin: '', // 外部参数 车牌
    }
  },
  watch: {
    $route: {
      handler(to) {
        const type = to.query.type
        // 外部调用 type 为1， 调用定位查询页面， 值为2 时调用轨迹查询页面
        if (type == 2) {
          this.$router.push({
            path: '/connect/contrail',
            query: { ...to.query },
          })
        }
      },
      immediate: true,
    },
  },
  async created() {
    const { key, fun, imei, carVin } = this.$route.query
    this.key = key
    this.fun = fun
    this.imei = imei
    this.carVin = carVin
    if (this.imei || this.carVin) {
      this.intshow()
    } else {
      this.$dialog
        .alert({
          title: '提示',
          message: '请传入需要定位的设备号或者车架号',
        })
        .then(() => {})
    }
  },
  computed: {
    // 定位信息
    locationInfo() {
      const options = {
       gps: {
          label: 'GPS定位',
          timer:  {
              label: '最后定位时间',
              value: 'gpsTime',
            },
          address:  {
              label: '最后定位位置',
              value: 'gpsAddress',
            },
           lng:  {
              label: '经度',
              value: 'lon',
            },
           lat:  {
              label: '纬度',
              value: 'lat',
            },
          
        },
        gsm: {
          label: '基站定位',
          timer:  {
              label: '最后定位时间',
              value: 'gsmTime',
            },
          address:  {
              label: '最后定位位置',
              value: 'gsmAddress',
            },
            lng:  {
              label: '经度',
              value: 'gsmLon',
            },
            lat:  {
              label: '纬度',
              value: 'gsmLat',
            },
          
        },
        wifi: {
          label: 'WIFI定位',
          timer:  {
              label: '最后定位时间',
              value: 'wifiTime',
            },
            address:  {
              label: '最后定位位置',
              value: 'wifiAddress',
            },
            lng:  {
              label: '经度',
              value: 'wifiLon',
            },
            lat:  {
              label: '纬度',
              value: 'wifiLat',
            },
        }
      }
      // 根据最新的定位时间判断当前的定位方式：GPS：gpsTime， 基站：gsmTime，WiFi： wifiTime
        const gpsTime =  new Date(this.devicedata.gpsTime).getTime() || 0
        const gsmTime = new Date(this.devicedata.gsmTime).getTime() || 0
        const wifiTime = new Date(this.devicedata.wifiTime).getTime() || 0
        // 获取最新的时间
        const time = Math.max(gpsTime, gsmTime, wifiTime)
        // 判断最新的定位时间是GPS，基站，WiFi
        const locationType = time === gpsTime ? 'gps' : time === wifiTime ? 'wifi' : 'gsm'


      return options[locationType] || {}
    },
  },
  methods: {
    changeDevice() {
      this.devicedata = this.deviceList.find(
        (it) => it.deviceId == this.deviceId
      )
      const location = this.locationInfo
      this.currentPoint.lng = this.devicedata[location.lng.value]
      this.currentPoint.lat = this.devicedata[location.lat.value]

      // 切换设备时，气泡被关掉了，用定时器重新开启气泡窗
      setTimeout(() => {
        this.openInfo()
      }, 100)
    },
    // 查看轨迹
    viewGrack() {
      const params = { ...this.$route.query }
      this.deviceList.length > 1 &&
        (params.imei = this.deviceList.find(
          (it) => it.deviceId == this.deviceId
        )?.sn)
      this.$router.push({ path: '/connect/contrail', query: { ...params } })
    },
    // 重绘地图定位
    initMap({ BMap, map }) {
      this.BMap = BMap
      this.map = map
    },
    cancel() {
      this.visible = false
    },
    colseInfo() {
      this.shows = false
    },
    openInfo() {
      this.shows = true
    },
    async intshow() {
      if (!this.imei && !this.carVin) {
        return
      }
      const param = {
        key: this.key,
        fun: this.fun,
        imei: this.imei,
        carVin: this.carVin,
      }
      const res = await getDeviceInfo(param)
      if (res && res.success) {
        this.deviceList = res.content

        this.devicedata = this.deviceId
          ? res.content.find((it) => it.deviceId === this.deviceId)
          : res.content[0]
        this.deviceId = this.devicedata.deviceId
        const location = this.locationInfo
        this.currentPoint.lng = this.devicedata[location.lng.value]
        this.currentPoint.lat = this.devicedata[location.lat.value]
        
        this.zoom = 18
        this.shows = true
        this.visible = true
      } else {
        this.$dialog
          .alert({
            title: '提示',
            message: '设备信息查询失败',
          })
          .then(() => {})
      }
    },
  },
}
</script>
<style lang="less" scoped>
.viewGrack {
  font-size: 0.08rem;
  color: #4095f7;
  line-height: 0.2rem;
  cursor: pointer;
}
.info-window-content {
  margin-top: 10px;
  border-top: 1px solid #dcdfe6;
  padding-top: 10px;
}
.location-info {
  margin-top: 10px;
}

.fontred {
  color: red;
  margin-top: 6px;
}

.title {
  font-size: 0.07rem;
  color: #000;
  font-weight: 600;
  line-height: 0.12rem;
}

.martin-top-10 {
  margin-top: 10px;
}

.van-col {
  // div {
  //   margin-top: .04rem;
  //   margin-left: .4rem;
  // }
}

.fontone {
  font-size: 0.07rem;
  line-height: 0.12rem;
  color: #666666;
  margin-top: 10px;
  margin-right: 4px;
}

.col {
  display: flex;
  align-items: center;
}
</style>
